export default __webpack_public_path__ + "static/media/SWT1690.34I-39107_-23035_0.2d9c990b.jpg";